// src/WordCard.js
import React from 'react';
import { useDrag } from 'react-dnd';
import './WordCard.css';

const WordCard = ({ word }) => {
  const [{ isDragging }, drag] = useDrag({
    type: 'word',
    item: { word },
    collect: (monitor) => ({
      isDragging: monitor.isDragging(),
    }),
  });

  return (
    <div ref={drag} className={`word-card ${isDragging ? 'dragging' : ''}`}>
      {word}
    </div>
  );
};

export default WordCard;
